<template src='./project-organizations.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import VueUploadComponent from 'vue-upload-component'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import { authorizedOrganizationId, hasProjectManageClaim, hasAdminClaim } from '@/router/auth'
import Autocomplete from '@/components/misc/autocomplete/Autocomplete'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage,
    Tabulator,
    Autocomplete,
    FileUpload: VueUploadComponent
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      organizations: {},
      organization: {},
      budgetUser: {
        id: ''
      },
      ProjectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      project: {},
      dialog: false,
      pageLoader: false,
      data: [],
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root + '/' + Vue.$apiConfig.projectOrganizationsGet.replace('{projectCode}', this.$route.params.projectCode),
        ajaxResponse: (url, params, response) => {
          this.project = response.additionalInformation.project
          this.showLoader(false)
          this.rowCount = response.additionalInformation.totalRows
          const retObj = {
            contentType: 'application/json; charset=utf-8',
            data: response.payload,
            last_page: this.getPageCount(this.rowCount)
          }
          if (this.switchTabulatorPage !== false && this.$refs.tabulator.getInstance === 'function') {
            this.$refs.tabulator.getInstance().modules.page.page = this.switchTabulatorPage
            this.switchTabulatorPage = false
          }
          const totalElement = document.getElementsByClassName('total-rows-number')
          if (totalElement.length && this.rowCount) {
            totalElement[0].innerHTML = this.rowCount
          } else {
            totalElement[0].innerHTML = '-'
          }
          return retObj
        },
        columns: [
          { title: '', field: 'id', visible: false, headerSort: false },
          {
            title: this.$t('organizationAdministration.budgetUserId'),
            field: 'organizationId',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('organizationAdministration.name'),
            field: 'organizationName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('projects.createdDate'),
            hozAlign: 'center',
            field: 'createdDate',
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatDate(cell.getValue()) : this.$t('general.undefined')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          },
          {
            headerSort: false,
            hozAlign: 'center',
            width: 40,
            formatter: 'tickCross',
            cellClick: (e, cell) => {
              this.deleteOrganizationPrompt(cell._cell.row.data)
              e.stopPropagation()
            }
          }
        ]
      }
    }
  },
  computed: {
    canManageOrganization () {
      return ((hasProjectManageClaim() && authorizedOrganizationId() === this.project.organizationId) || hasAdminClaim()) && this.project.status === this.ProjectStatus.PENDING
    }
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    autocompleteFilter (query) {
      console.log(parseInt(query))
      if (isNaN(parseInt(query))) {
        // we check for name
        return 'filter[name]'
      } else {
        // we check for id
        return 'filter[id]'
      }
    },
    budgetUserSelected (budgetUser) {
      if (!this.isObject(budgetUser)) return
      this.budgetUser.id = budgetUser.id
    },
    prepareBudgetUsersResponseData (data) {
      return data.body.payload
    },
    addOrganization () {
      if (!this.budgetUser.id) {
        return
      }
      const model = {
        add: [this.budgetUser.id]
      }

      this.setOrganization(model)
    },
    deleteOrganizationPrompt (organization) {
      if (!this.canManageOrganization) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('projects.deleteOrganizationPermission'),
          errors: []
        })
        return
      }
      this.organization.id = organization.organizationId
      this.dialog = true
    },
    deleteOrganization () {
      const model = {
        remove: [this.organization.id]
      }

      this.setOrganization(model)
    },
    setOrganization (model) {
      this.showLoader(true)
      this.pageLoader = true
      this.$http.put(Vue.$apiConfig.setOrganziationPut.replace('{projectCode}', this.$route.params.projectCode), model)
        .then(
          response => {
            this.tabulatorInstance.setData()
            this.budgetUser.id = ''
            this.organization.id = ''
            this.$refs.budgetUserAutocomplete.query = ''
            this.showLoader(false)
            this.pageLoader = false
            this.dialog = false
            const error = response.body.payload.add[0].error
            if (error != null) {
              EventBus.$emit('alert', {
                variant: 'error',
                message: this.$t('apiStatusCodes.' + error.code),
                errors: []
              })
            }
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.pageLoader = false
          }
        )
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
      this.pageLoader = loader
    }
  }
}
</script>
